// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'


export const getTranspoterData = createAsyncThunk('appUsers/getTranspoterData', async params => {
  // console.log("params>>", params)
  const response = await axios.get(`${process.env.REACT_APP_API_URL}admin/allTranspoter`, { params })
  console.log("transresponse>>", response)
  return {
    params,
    allData: response.data.alltranspoter,
    data: response.data.transpoter,
    totalPages: response.data.transpoterCount
  }
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  console.log("getstate>>>", getState())
  await axios.get(`${process.env.REACT_APP_API_URL}admin/removeTranspoter/${id}`)
  await dispatch(getTranspoterData(getState().transpoters.params))
  // await dispatch(getAllData())
  return id
})


export const appUsersSlice = createSlice({
  name: 'getTranspoterData',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getTranspoterData.fulfilled, (state, action) => {
        state.allData = action.payload.allData
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
  }
})

export default appUsersSlice.reducer
